import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import {ReferenceTableService} from '../reference-table.service';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService, DateUtility, INVALID_EMAIL } from '../shared';
import {ProviderService} from "../provider-management/provider-management.service";
import {GridOptions} from "ag-grid/main";
import { NotificationsService } from 'angular2-notifications';
import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-admin-provider-office',
  templateUrl: './admin-provider-office.component.html',
  styleUrls: ['./admin-provider-office.component.scss']
})
export class AdminProviderOfficeComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  @ViewChild('fileInput') fileInput:ElementRef;
  @ViewChild('emailField') emailField: ElementRef;
  @ViewChild('emailMsg') emailMsg: ElementRef;
  loaderFocus: Boolean = false;

  private gridApi;
  firstTime: Boolean = true;
  private gridOptions;
  private gridColumnApi;
  private rowData: any=[];

  private columnDefs;
  private components;
  tabIndex:any = "-1";
  tabIndex1:any = "0";
  counties:any=[];
  selectedCounty:any = "Pick An Option";
  private isAddDisable:Boolean;
  today: Date = new Date();
  minESDate:NgbDateStruct;
  minRDDate: NgbDateStruct;
  maxRDDate: NgbDateStruct;
  minECDate: NgbDateStruct;
  isEdit:Boolean = true;
  isResetDisable:Boolean = true;
  initialData:Boolean;
  private editData:any;
  tabToNextCell:any;
  private officeDetails:any={
    "id":"",
    "recordVersion":"",
    "serviceCounty": "",
    "officeName": "",
    "primaryContactFirstName": "",
    "primaryContactLastName": "",
    "primaryAddrLine1": "",
    "primaryAddrLine2": "",
    "primaryCity": "",
    "primaryState": "",
    "primaryZip5": "",
    "primaryZip4": "",
    "primaryPhoneNumber": "",
    "primaryPhoneNumberExt":null,
    "primaryFaxNumber": "",
    "primaryEmail": "",
    "officeBeginDt": "",
    "officeEndDt": null,
    "provider":""
}
  isChangeDetected: boolean;  
  errorEmailField: string = null;
  validEmail = true;

  constructor(private referenceTable: ReferenceTableService,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private dateUtil:DateUtility,
    private providerService: ProviderService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService,
    private router: Router
    ) {
      this.gridOptions = <GridOptions>{
        context: {
            componentParent: this
        },
        defaultColDef: {
          width: 200,
          editable: false,
          filter: 'agTextColumnFilter'
        }
      };
      if(this.dataService.getSharedDataObject().get("ADPSH") == undefined){
        this.router.navigate(['/admin/provider-management']);
      }
   }

  ngOnInit() {
    this.dataService.globalAccess = true;
    this.defineColumns();
    this.minESDate = {
      month: this.today.getMonth()+1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    this.minRDDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    };
    this.minECDate = {
      month: this.today.getMonth() + 1,
      day: this.today.getDate(),
      year: this.today.getFullYear()
    }
    this.counties.push("Pick An Option");
    this.getCounties();
    if(this.dataService.getSharedDataObject().get("provider")== undefined){
      this.isAddDisable = true;
      this.tabIndex = "0";
    }
    else{
      this.isAddDisable = false;
    }
    
  }
  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    //this.gridColumnApi.setColumnVisible("Action", false);
    params.api.setGridAutoHeight(true);
    params.api.sizeColumnsToFit();
  }
  countyChanges(event) {
    this.loaderFocus = true;
    event.srcElement.blur();
    event.preventDefault();
    this.rowData = [];
    this.getrowData();
  }
  onAddRow() {
    this.loaderFocus = false;
    this.isEdit = false;
  }
  defineColumns(){
    this.columnDefs = [
      {
        headerName: "County Name",
        field: "county"
      },
      {
        headerName: "Office Name",
        field: "office"
      },
      {
        headerName: "Office Begin Date",
        field: "beginDt"
      },
      {
        headerName: "Office End Date",
        field: "endDt"
      },
      { headerName: 'Action',
       field: 'Action', 
       cellRenderer: this.getEditButton,
       suppressFilter: true,
       suppressSorting: true
      }
    ];
    this.tabToNextCell = function tabToNextCell(params) {
      var nextCell = params.nextCellDef;
      if(nextCell.column.colDef.headerName === "Action"){
        return;
      }
      else{
        return nextCell;
      }
    }
  }
  getrowData(){
    this.dataService.removeValueFromSharedDataMap('office');
    let providerId = this.dataService.getSharedDataObject().get("provider").id;
    let countyId = this.getvalue(this.selectedCounty);
    this.minESDate = this.dateUtil.convertDateFromServer(this.getcountyDetails(countyId).serviceBeginDt);
    this.maxRDDate = this.dateUtil.convertDateFromServer(this.getcountyDetails(countyId).serviceEndDt);
    this.providerService.getofficeDetails(providerId, countyId).subscribe((data)=>{
      this.editData = data;
      for(let i=0;i <data.length; i++){
        this.rowData.push({
          county:this.selectedCounty,
          office:data[i].officeName,
          beginDt:this.dateUtil.convertFormattedDateFromServer(data[i].officeBeginDt),
          endDt:this.dateUtil.convertFormattedDateFromServer(data[i].officeEndDt),
          id:i
        })
      }
      this.gridColumnApi.setColumnVisible("Action", true);
      this.gridApi.setRowData(this.rowData);
    })
  }
  getvalue(key){
    for(let i=0; i<this.referenceTable.getValueFromSharedDataMap('COUNTIES').length; i++){
      if(this.referenceTable.getValueFromSharedDataMap('COUNTIES')[i].name == key){
        return this.referenceTable.getValueFromSharedDataMap('COUNTIES')[i].value;
      }
    }
  }
  getname(key){
    for(let i=0; i<this.referenceTable.getValueFromSharedDataMap('COUNTIES').length; i++){
      if(this.referenceTable.getValueFromSharedDataMap('COUNTIES')[i].value == key){
         return this.referenceTable.getValueFromSharedDataMap('COUNTIES')[i].name;
      }
    }
  }
  getEditButton(params) {
    const that = params.context.componentParent;
    const element = document.createElement('a');
    element.innerHTML = "<i class='fa fa-pencil'></i>";
    element.addEventListener('click', () => {
      that.dataService.addValueToSharedDataMap('office',that.editData[params.data.id]);
      //this.router.navigate(['admin/provider-details']);
      //console.log("Hello");
      that.isEdit = false;
      that.loaderFocus = false;
      that.getData();
      //console.log(that.dataService.getSharedDataObject().get("office"));
    });
    element.addEventListener('keydown', (event) => {
      if(event.keyCode == 13 || event.keyCode == 32){
        that.dataService.addValueToSharedDataMap('office',that.editData[params.data.id]);
        that.isEdit = false;
        that.loaderFocus = false;
        that.getData();
      }
    });
    element.setAttribute("tabindex", "0");
    return element;
  }
  restrictSpaceSpecial(event){
    if(!(/[a-zA-Z0-9-' ]/.test(event.key))){
     event.returnValue = false;
     return;
    }
     event.returnValue = true;
   }
   restrictSpecial(event){
     if(!(/[a-zA-Z0-9 ]/.test(event.key))){
       event.returnValue = false;
       return;
      }
       event.returnValue = true;
   }
   replaceSpecial(){
    this.officeDetails.primaryContactFirstName = this.officeDetails.primaryContactFirstName.toString().replace(/[^a-zA-Z 0-9-'\n\r]+/g, '');
    this.officeDetails.primaryContactLastName = this.officeDetails.primaryContactLastName.toString().replace(/[^a-zA-Z 0-9-'\n\r]+/g, '');
  }
  restrict(event){
    if(!((event.shiftKey === false) && (event.keyCode >= 48) && (event.keyCode <= 57) || (event.keyCode == 9) || (event.keyCode >= 96) && (event.keyCode <= 105) || (event.keyCode>=37) && (event.keyCode<=40) || (event.keyCode == 32) || (event.keyCode ==8))){
      event.returnValue = false;
      return;
   }
    event.returnValue = true;
  }
  dataChanges(){
    this.isResetDisable=false;
    this.tabIndex = "-1";
    this.isChangeDetected=true;
    if(this.officeDetails.primaryZip5.length >=9 || this.officeDetails.primaryZip5.length ==5){
      this.officeDetails.primaryZip5 = this.officeDetails.primaryZip5;
    }
    else{
      this.officeDetails.primaryZip5 = "";
    }
  }
  getValidEmail() {
    return this.validEmail;
  }
  validateEmail(event){
    const regExp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if(this.officeDetails.primaryEmail !== null && this.officeDetails.primaryEmail !== undefined) {
      if(!regExp.test(String(this.officeDetails.primaryEmail).toLowerCase())){
        this.errorEmailField = INVALID_EMAIL;
        this.emailField.nativeElement.classList.remove("ng-valid");
        this.emailField.nativeElement.classList.add("ng-invalid");
        this.emailMsg.nativeElement.classList.add("d-block");
        this.emailMsg.nativeElement.classList.remove("d-none");
        this.validEmail = false;
      }
      else{
        this.emailField.nativeElement.classList.remove("ng-invalid");
        this.emailField.nativeElement.classList.add("ng-valid");
        this.emailMsg.nativeElement.classList.remove("d-block");
        this.emailMsg.nativeElement.classList.add("d-none");
        this.errorEmailField = null;
        this.validEmail = true;
      }
    }
  }
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };
  getFromDate() {
    this.minECDate = {
      month: this.officeDetails.officeBeginDt["month"],
      day: this.officeDetails.officeBeginDt["day"],
      year: this.officeDetails.officeBeginDt["year"]
    }
  }
  save(){
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    this.fileInput.nativeElement.click();
    this.isChangeDetected=false;
    console.log(this.dataService.getSharedDataObject().get("office"));
    this.officeDetails.serviceCounty = this.getvalue(this.selectedCounty);
    this.officeDetails.provider = this.dataService.getSharedDataObject().get("provider");
    let token = this.dataService.getSharedDataObject().get("token");
    this.officeDetails.officeBeginDt= this.dateUtil.convertDateForServer(this.officeDetails.officeBeginDt);
    this.officeDetails.officeEndDt= this.dateUtil.convertDateForServer(this.officeDetails.officeEndDt);
    if( this.officeDetails.primaryZip5.length >=9){
      if(this.officeDetails.primaryZip5.length == 10){
        this.officeDetails.primaryZip4 =  this.officeDetails.primaryZip5.slice(6,10);
      }
      else{
        this.officeDetails.primaryZip4 =  this.officeDetails.primaryZip5.slice(5,10);
      }
      this.officeDetails.primaryZip5 =  this.officeDetails.primaryZip5.slice(0,5);
    }
    else{
      this.officeDetails.primaryZip4 =  '';
    }
    if(this.officeDetails.primaryEmail.slice(-1) === "_" ||  this.officeDetails.primaryZip5.length !==5 || !this.validEmail){
      if(!this.validEmail){
        this.notificationService.error('Enter a Valid Format for Email Field');
      }
      else{
        this.notificationService.error('Enter a Valid ZipCode Field');
      }
      this.officeDetails.officeBeginDt= this.dateUtil.convertDateFromServer(this.officeDetails.officeBeginDt);
      this.officeDetails.officeEndDt= this.dateUtil.convertDateFromServer(this.officeDetails.officeEndDt);
    }
    else{
      this.providerService.saveOfficeDetails(token,this.officeDetails).subscribe((data)=>{
        if(data.id){
          this.notificationService.success('Assign Provider Office saved successfully');
          this.officeDetails.recordVersion = data.recordVersion;
          this.officeDetails.id = data.id;
          this.officeDetails.officeBeginDt= this.dateUtil.convertDateFromServer(data.officeBeginDt);
          this.officeDetails.officeEndDt= this.dateUtil.convertDateFromServer(data.officeEndDt);
          setTimeout(() => this.headerText.nativeElement.focus(), 0);
          this.headerText.nativeElement.click();
          if(data.primaryZip4 !== ""){
            this.officeDetails.primaryZip5 = data.primaryZip5 + "-" + data.primaryZip4;
          }
          else{
            this.officeDetails.primaryZip5 = data.primaryZip5;
          }
          this.getrowData();
        }
        else{
          this.notificationService.error('System Error:Please contact Help Desk');
          this.officeDetails.officeBeginDt= this.dateUtil.convertDateFromServer(data.officeBeginDt);
          this.officeDetails.officeEndDt= this.dateUtil.convertDateFromServer(data.officeEndDt);
          if(this.officeDetails.primaryZip4 !== ""){
            this.officeDetails.primaryZip5 = this.officeDetails.primaryZip5  + this.officeDetails.primaryZip4;
          }
          else{
            this.officeDetails.primaryZip5 = this.officeDetails.primaryZip5;
          }
        }
        //this.isEdit = true;
      })
    }
  }
  getData(){
    if(this.dataService.getSharedDataObject().get("office")== undefined){
      this.initialData = true;
    }
    else{
      this.initialData = false;
      this.dataInit();
    }
  }
  reset(){
    if(this.initialData){
      this.officeDetails ={};
    }
    else{
      this.dataInit();
    }
  }
  dataInit(){
      this.officeDetails.id = this.dataService.getSharedDataObject().get("office").id;
      this.officeDetails.recordVersion = this.dataService.getSharedDataObject().get("office").recordVersion;
      this.officeDetails.officeName = this.dataService.getSharedDataObject().get("office").officeName;
      this.officeDetails.primaryContactFirstName = this.dataService.getSharedDataObject().get("office").primaryContactFirstName;
      this.officeDetails.primaryContactLastName = this.dataService.getSharedDataObject().get("office").primaryContactLastName;
      this.officeDetails.primaryAddrLine1 = this.dataService.getSharedDataObject().get("office").primaryAddrLine1;
      this.officeDetails.primaryAddrLine2 = this.dataService.getSharedDataObject().get("office").primaryAddrLine2;
      this.officeDetails.primaryCity = this.dataService.getSharedDataObject().get("office").primaryCity;
      this.officeDetails.primaryState = this.dataService.getSharedDataObject().get("office").primaryState;
      if(this.dataService.getSharedDataObject().get("office").primaryZip4 !== ""){
        this.officeDetails.primaryZip5 = this.dataService.getSharedDataObject().get("office").primaryZip5  + this.dataService.getSharedDataObject().get("office").primaryZip4;
      }
      else{
        this.officeDetails.primaryZip5 = this.dataService.getSharedDataObject().get("office").primaryZip5;
      }
      this.officeDetails.primaryPhoneNumber = this.dataService.getSharedDataObject().get("office").primaryPhoneNumber;
      this.officeDetails.primaryPhoneNumberExt = this.dataService.getSharedDataObject().get("office").primaryPhoneNumberExt;
      this.officeDetails.primaryFaxNumber = this.dataService.getSharedDataObject().get("office").primaryFaxNumber;
      this.officeDetails.primaryEmail = this.dataService.getSharedDataObject().get("office").primaryEmail;
      this.officeDetails.officeBeginDt = this.dataService.getSharedDataObject().get("office").officeBeginDt;
      this.officeDetails.officeEndDt = this.dataService.getSharedDataObject().get("office").officeEndDt;
      this.officeDetails.officeBeginDt= this.dateUtil.convertDateFromServer(this.officeDetails.officeBeginDt);
      this.officeDetails.officeEndDt = this.dateUtil.convertDateFromServer(this.officeDetails.officeEndDt);
  }
  getcountyDetails(countyKey){
    for(let i=0; i< this.dataService.getSharedDataObject().get("counties").length;i++){
      if(countyKey == this.dataService.getSharedDataObject().get("counties")[i].serviceCounty){
        return this.dataService.getSharedDataObject().get("counties")[i];
      }
    }
  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }
  getCounties(){
    let id = this.dataService.getSharedDataObject().get("provider").id;
    this.providerService.getcountyDetails(id).subscribe((data)=>{
      this.dataService.addValueToSharedDataMap('counties',data);
      for(let i=0; i< this.dataService.getSharedDataObject().get("counties").length;i++){
        this.counties.push(this.getname(this.dataService.getSharedDataObject().get("counties")[i].serviceCounty));
      }
    });
  }
  addEventListenerToSearch(event){
    var tabKeyCode = 9; 
    
    // ignore non tab key strokes 
    if(event.keyCode !== tabKeyCode) {
      return; 
    }
    if(this.rowData.length === 0){
      return;
    }

    if(event.shiftKey){
      return true; // unbind preventDefault when navigating backwards     
    } else {
      // prevents tabbing into the url section when navigating forward  
      event.preventDefault(); 
    }

    // set focus on the first cell in the ag-grid
    this.setDisplayedRowAtIndex();
  }
  setDisplayedRowAtIndex() {
    // get the first row
    var index = this.gridApi.getFirstDisplayedRow();
    var rowNode = this.gridApi.getDisplayedRowAtIndex(index);

    // scrolls to the first row 
    //this.gridApi.ensureIndexVisible(0, 'top'); 

    // scrolls to the first column 
    var firstCol = rowNode.columnApi.getAllDisplayedColumns()[0];
    this.gridApi.ensureColumnVisible(firstCol);

    // sets focus into the first grid cell 
    this.gridApi.setFocusedCell(index, firstCol);
  }
  focusSummary(event) {
    if(this.rowData.length === 0){
      this.focusing(event);
    }
    else{
      this.firstTime = false;
      this.addEventListenerToSearch(event);
    }
  }

  onPaginationChanged() {
    if (this.firstTime) {
      return;
    } else {
      if (this.gridApi) {
        this.setDisplayedRowAtIndex();
      }
    }
  }


  gridClick() {
    this.firstTime = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/admin-provider-office/admin-provider-office.component.ts